import { Link } from 'react-router-dom';
import { trackPartnerEvent } from '../hooks/useCandidaturaAnalytics';

export default function PartnerRecruitmentBanner({ compact = false, catalogoPreview = false }) {
  const handleClick = (source) => {
    trackPartnerEvent('partner_cta_click', { source });
  };

  if (compact) {
    return (
      <div className="bg-[#fff8ea] border-b border-[#f3deb8] px-3 py-2 text-center text-xs text-[#7a4a1f] flex flex-wrap items-center justify-center gap-2">
        {catalogoPreview && <strong>Anteprima</strong>}
        <span>Sei produttore artigianale?</span>
        <Link
          to="/diventa-partner"
          onClick={() => handleClick('catalogo_compact')}
          className="text-[#c78244] font-semibold underline"
        >
          Vendi su Mangitalia →
        </Link>
      </div>
    );
  }

  return (
    <div className="bg-[#fff8ea] border-b border-[#f3deb8]">
      <div className="max-w-7xl mx-auto px-3 py-2.5 sm:px-4 sm:py-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-sm text-[#7a4a1f]">
        <p>
          {catalogoPreview && (
            <span className="inline-block bg-[#F6CF48] text-[#5c3d1e] text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full mr-2">
              Anteprima
            </span>
          )}
          <strong>Produttori e partner logistica:</strong> candidati gratis — nessuna commissione, pagamento alla consegna.
        </p>
        <div className="flex flex-wrap gap-3 shrink-0">
          <Link
            to="/diventa-partner"
            onClick={() => handleClick('catalogo_banner')}
            className="text-[#c78244] font-semibold underline text-xs sm:text-sm"
          >
            Scopri come candidarti →
          </Link>
          <Link
            to="/candidatura"
            onClick={() => handleClick('catalogo_direct')}
            className="bg-[#c78244] text-white text-xs sm:text-sm font-semibold px-3 py-1 rounded-full hover:opacity-90"
          >
            Inizia in 2 minuti
          </Link>
        </div>
      </div>
    </div>
  );
}
